<template lang="html">
  <form action="">
    <div v-for="(formItem, index) in formData" :key="formItem.id">

      <template v-if="formItem.type == 1">
        <!-- Text field -->
        <v-text-field
          :label="formItem.name"
          :required="Boolean(formItem.required)"
          :hint="formItem.description"
          persistent-hint
          v-model="formData[index].value">
        </v-text-field>
      </template>

      <template v-else-if="formItem.type == 2">
        <!-- Multiline text field -->
        <v-text-field
          :label="formItem.name"
          multi-line
          :required="Boolean(formItem.required)"
          :hint="formItem.description"
          persistent-hint
          :rules="[rules.required]"
          v-model="formData[index].value">
        </v-text-field>
      </template>

      <template v-else-if="formItem.type == 3">
        <!-- E-mail text field -->
        <v-text-field
          :label="formItem.name"
          :required="Boolean(formItem.required)"
          :hint="formItem.description"
          persistent-hint
          :rules="Boolean(formItem.required) ? [rules.required, rules.email] : [rules.email]"
          v-model="formData[index].value"
          prepend-icon="at"
        ></v-text-field>
      </template>

      <template v-else-if="formItem.type == 4">
        <!-- Date field -->
        <v-menu
          :close-on-content-click="true"
          v-model="formMenus[index]"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="formData[index].value"
            :label="formItem.name"
            :required="Boolean(formItem.required)"
            :rules="Boolean(formItem.required) ? [rules.required] : []"
            prepend-icon="event"
            :readonly="true"
          />
          <v-date-picker 
            v-model="formData[index].value" 
            no-title
            :first-day-of-week="1"
            locale="ru-ru"
          />
        </v-menu>
      </template>

      <template v-else-if="formItem.type == 5">
        <v-checkbox
          :label="formItem.name"
          :hint="formItem.description"
          persistent-hint
          v-model="formData[index].value">
        </v-checkbox>
      </template>

      <template v-else-if="formItem.type == 6">
        <!-- Radio Button -->
        <v-radio-group v-model="formData[index].value" :label="formItem.name">
          <v-radio
            v-for="item in formItem.options.list"
            :key="item.key"
            :label="`${item.value}`"
            :value="`${item.value}`"
          ></v-radio>
        </v-radio-group>
      </template>

      <template v-else-if="formItem.type == 7">
        <!-- Select -->
        <v-flex xs12>
          <v-select
            v-model="formData[index].value"
            :items="formItem.options.list.map(item => item.value)"
            :label="formItem.name"
          ></v-select>
        </v-flex>
      </template>

      <template v-else-if="formItem.type == 8">
        <!-- Select -->
        <v-flex xs12>
          <v-select
            v-model="formData[index].value"
            :items="formItem.options.list"
            :label="formItem.name"
          ></v-select>
        </v-flex>
      </template>

      <template v-else>
        <v-alert :value="true" color="error" outline>
          Указан неподдерживаемый тип данных формы ({{ formItem.type }}).
        </v-alert>
      </template>
    </div>

    <!-- <small v-if="formData && formData.length">* эти поля обязательны для заполнения</small> -->
  </form>
</template>

<script>

  import httpClient from '@/api/http-client'

  const http = httpClient.http

  export default {

    props: {

      formData: {
        type: Array,
        default: function () {
          return []
        }
      }
    },

    data() {

      return {
        // Form fields validation rules
        rules: {

          required: (value) => !!value || 'Обязательно для заполнения.',

          email: (value) => {
            const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Неверный e-mail.'
          }
        }
      }
    },

    mounted() {

      this.init()
    },

    methods: {

      /**
       * Инициализация формы.
       *
       */
      init: function () {

        // Обработка параметров формы.
        this.formData.forEach((element, index) => {

          // Установка значения по умолчанию для параметра типа Переключатель.
          if (element.options && element.options.list && Array.isArray(element.options.list)) {
            element.value = element.options.list[element.options.default].value
          }

          // Получение от стороннего API списка данных для параметра
          // типа Выпадающий список (источник внешних данных).
          if (element.type == 8) {
            this.getServerData(element)
          }
        })
      },

      /**
       * Получение по внешнему API списка данных.
       *
       * @param element
       */
      getServerData: function (element) {

        let apiPath = element.options.url

        http.get( apiPath ).then(response => {

          if (response.status == 200 && response.data) {

            this.$set(element.options, 'list', response.data.list)
            this.$set(element.options, 'default', response.data.default)
            this.setDefault(element)
          }
          else {

            console.error('Неверный формат данных, полученных по внешнему API.')
          }
        }).catch(error => {

          console.warn(error)
        }).finally(() => {

        })
      },

      /**
       * Установка в списке данных значения по умолчанию.
       *
       * @param element
       */
      setDefault: function (element) {
        this.$set(element, 'value', element.options.list[element.options.default])
      }
    }
  }
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/apps/bpm/monitor/components/FlexForm.vue